import React from 'react';
import { HighlightedCard } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { Link } from '@components/common/Link';
import { useRoomTemperature } from '@hooks/useRoomTemperature';
import { ROUTES } from '@routes/routes.constants';
import { localizationStore } from '@stores/localization';

export const TemperatureCard = observer(
  ({ className }: { className?: string }) => {
    const t = localizationStore.getTranslation;

    const { mostRecent } = useRoomTemperature();

    if (!mostRecent)
      return (
        <HighlightedCard
          layout="horizontal"
          icon="temperature"
          iconPosition="left"
          title={t('apartmentTemperature')}
          body={t('apartment_temperature_fallback_body_text')}
          buttonProps={{
            children: t('read_more'),
            to: ROUTES.TEMPERATURE,
            icon: 'arrowRight',
            iconPosition: 'right',
            wrapperComponent: Link,
          }}
          color="secondary"
          className={className}
        />
      );

    return (
      <HighlightedCard
        layout="horizontal"
        icon="temperature"
        iconPosition="left"
        pretitle={t('apartmentTemperature')}
        title={`${mostRecent.value.toFixed(1)} °C`}
        buttonProps={{
          children: t('apartmentHeatingLink'),
          to: ROUTES.TEMPERATURE,
          icon: 'arrowRight',
          iconPosition: 'right',
          wrapperComponent: Link,
        }}
        color="secondary"
        className={className}
      />
    );
  }
);
